const { applyGlitch, removeGlitch } = require("./utils/apply-glitch.js");
const {
  findTargetById,
  findSpriteByName,
} = require("../shared_utils/find-target.js");
const log = require("../shared_utils/log.js");
const { sanitizeVariables } = require("./utils/sanitize-state.js");
module.exports = function store(state, emitter) {
  emitter.on("reapply-glitch", (glitchApplicationId) => {
    const glitchApplication = state.glitchApplications.find(
      (g) => g.id === glitchApplicationId
    );
    emitter.emit("remove-glitch", glitchApplicationId);
    emitter.emit(
      "apply-glitch",
      glitchApplication.glitchId,
      glitchApplication.targetId
    );
  });
  emitter.on("apply-glitch", (glitchId, targetId) => {
    log("apply glitch", glitchId, targetId);
    const glitch = state.availableGlitches.find((g) => g.id === glitchId);
    const target = state.vm.runtime.targets.find((t) => t.id === targetId);

    const [original] = target.sprite.clones;
    const previousApplication = state.glitchApplications.find(
      (g) => g.glitchId === glitchId && g.targetId === original.id
    );
    let glitchApplication;
    if (previousApplication) {
      glitchApplication = previousApplication;
      // move the glitch to the end of the list
      state.glitchApplications = state.glitchApplications.filter(
        (g) => g !== previousApplication
      );
      state.glitchApplications.push(glitchApplication);
    } else {
      // check if this glitch has already been applied to any target
      const previousApplication = state.glitchApplications.find(
        (g) => g.glitchId === glitchId
      );
      let copyStageBlocks = true;
      if (previousApplication) {
        copyStageBlocks = false;
      }

      glitchApplication = applyGlitch(
        glitch,
        original,
        state.vm,
        copyStageBlocks
      );
      state.glitchApplications.push(glitchApplication);
    }
    sanitizeVariables(state);
    if (target && glitch.id === "grid_layout") {
      emitter.emit("set-grid-layout", target);
    }
    emitter.emit("render");
  });

  emitter.on("remove-glitch", (glitchApplicationId) => {
    log("remove-glitch", glitchApplicationId);
    const glitchApplication = state.glitchApplications.find(
      (g) => g.id === glitchApplicationId
    );
    const target = state.vm.runtime.targets.find(
      (t) => t.id === glitchApplication.targetId
    );
    const shouldDelete = [];
    if (glitchApplication.glitchId === "grid_layout") {
      target.sprite.clones.forEach((c) => {
        if (c.isOriginal) {
          return;
        }
        const is_gridclone = Object.values(c.variables).find(
          (v) => v.name === "is_gridclone?"
        );
        if (is_gridclone.value === "true" || is_gridclone.value === true) {
          shouldDelete.push(c);
        }
      });
    }
    shouldDelete.forEach((c) => {
      state.vm.runtime.disposeTarget(c);
    });
    state.vm.runtime.renderer.draw();
    removeGlitch(target, state.vm, glitchApplication);
    state.glitchApplications = state.glitchApplications.filter(
      (g) => g !== glitchApplication
    );
    if (state.selectedGlitchApplicationId === glitchApplicationId) {
      state.selectedGlitchApplicationId = null;
    }
    emitter.emit("render");
  });

  emitter.on("start-applying-glitch", (glitchId) => {
    log("start-applying-glitch", glitchId);
    state.applyingGlitch = true;
    emitter.emit("select-glitch", glitchId);
    emitter.emit("render");
  });

  emitter.on("end-applying-glitch", () => {
    log("end-applying-glitch");
    if (state.hoveringTargetId) {
      const glitch = state.availableGlitches.find(
        (g) => g.id === state.selectedGlitchId
      );
      const targetId = state.hoveringTargetId;
      emitter.emit("push-history", "glitch-application");
      emitter.emit("apply-glitch", glitch.id, targetId);
      emitter.emit("select-target", targetId);
      const glitchApplication = state.glitchApplications[state.glitchApplications.length - 1];
      const glitchApplicationId = glitchApplication.id;
      
      emitter.emit("select-glitch-application", glitchApplicationId);

      state.hoveringTargetId = null;
      const spriteVariables = glitch.exposedVariables.filter(
        (v) => v.input.type === "sprite"
      );
      const target = findTargetById(state.vm, targetId);
      let varToPick = false;
      spriteVariables.forEach((v) => {
        const variable = Object.values(target.variables).find(
          (targetVar) => targetVar.name === v.variableName
        );
        if (variable) {
          const matchingTarget = findSpriteByName(state.vm, variable.value);
          if (!matchingTarget) {
            varToPick = variable;
          }
        }
      });
    emitter.emit("deselect-glitch");
      if (varToPick) {
        emitter.emit("start-setting-sprite-variable", varToPick.id);
      }
    }


    emitter.emit("render");
  });
};
